import { css } from "@emotion/react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CustomScrollbars } from "../components/CustomScrollbars/CustomScrollbars";
import { LoginForm } from "../components/LoginForm";
import { SiteLayout } from "../components/SiteLayout";
import { AppConstants } from "../data/AppConstants";
import { useLoginFormState } from "../hooks/useLoginFormState";
import { useSessionState } from "../hooks/useSessionState";

export const LoginPage = () => {
	const loginFormState = useLoginFormState();
	const sessionState = useSessionState();
	const loggedIn = sessionState.get().loggedIn;
	const navigate = useNavigate();
	const location = useLocation();
	const redirectParam = new URLSearchParams(location.search).get("redirect");
	const redirectPath =
		redirectParam?.startsWith("/") && !redirectParam.startsWith("//")
			? redirectParam
			: "/";

	useEffect(() => {
		loginFormState.setIsPopup(false);
	}, [loginFormState]);

	useEffect(() => {
		if (loggedIn) {
			navigate(redirectPath, { replace: true });
		}
	}, [loggedIn, navigate, redirectPath]);

	if (loggedIn) {
		return null;
	}

	return (
		<SiteLayout
			title={loginFormState.translate("Login")}
			mainChildren={
				<CustomScrollbars className="flex-1 flex items-center justify-center">
					<div
						className={`flex-1 mx-auto flex items-center justify-center]`}
						css={css`max-width:${AppConstants.siteWidthCss};`}
					>
						<LoginForm />
					</div>
				</CustomScrollbars>
			}
		/>
	);
};
